let Path = {
    Home: '/',
    Register: '/register',
    Forget: '/forget',
    Login: '/login',
    Equipment: '/Equipment',
    AddEq: '/equipment/add',
    SceneMange: '/equipment/scene',
    RoomMange: '/equipment/room/:id',
    ChooseHome: '/equipment/choosescene/:type',
    ChooseRoom: '/equipment/chooseroom/:type/:sceneId',
    Info: '/equipment/info/:id',
    Status: '/equipment/status/:id',
    Detail: '/equipment/detail/:id',
    FanDetail:'/equipment/fan/:id',
    Timer: '/equipment/timer/:type/:id',
    AddTimer: '/equipment/timer/add/:id/:type',
    Repair: '/repair',
    RepairWx: '/repair_wx',
    Fault: '/fault/:id',
    Personal: '/personal',
    Self: '/personal/self',
    ResetPhone: '/personal/phone',
    Service: '/service',
    ServiceDetail: '/service/detail/:id',
    AboutUs: '/about',
    ConnectNet: '/connect',
    // Explain:'/explain',
    FreshAirDetail: '/fresh/detail/:id',
    FreshAirDehum: '/fresh/dehum/:id',
    // FreshAirStatus: '/fresh/status/:id',
    FreshAirParams: '/fresh/params/:id',
    FreshStatus1: '/fresh/status1/:id',
    FreshStatus2: '/fresh/status2/:id',
    FreshStatus3: '/fresh/status3/:id',
    FreshStatus4: '/fresh/status4/:id',
    FreshStatus5: '/fresh/status5/:id',
    FreshStatus6: '/fresh/status6/:id',
    FreshStatus7: '/fresh/status7/:id',
    FreshStatus8: '/fresh/status8/:id',
};

let PATH = {
    getScene() {
        return '/equipment/scene/'
    },
    getChooseHome() {
        return '/equipment/choosescene/'
    },
    getChooseRoom() {
        return '/equipment/chooseroom/'
    },
    getRoomMange() {
        return '/equipment/room/'
    },
    goDetail() {
        return '/equipment/detail/'
    },
    goFanDetail() {
        return '/equipment/fan/'
    },
    goFreshDetail() {
        return '/fresh/detail/'
    },
    goFreshStatus1() {
        return '/fresh/status1/'
    },
    goFreshStatus6() {
        return '/fresh/status6/'
    },
    goDehumDetail() {
        return '/fresh/dehum/'
    },
};

export {Path, PATH}




// WEBPACK FOOTER //
// ./src/router/path.js